import { render, staticRenderFns } from "./ListKundenOfBenutzer.vue?vue&type=template&id=021c4baa"
import script from "./ListKundenOfBenutzer.vue?vue&type=script&lang=js"
export * from "./ListKundenOfBenutzer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports